export default function PhilosophySection() {
  const ideas = [
    {
      icon: 'ri-service-line',
      title: 'Продажа — это помощь в принятии решения',
      desc: 'Не манипуляция и не давление. Настоящие продажи строятся на понимании потребностей клиента и искреннем желании помочь. Когда продавец становится советником, а не «впаривателем», меняется всё: конверсия, средний чек, лояльность.'
    },
    {
      icon: 'ri-flag-line',
      title: 'Руководитель создаёт культуру команды',
      desc: 'Не должность и не KPI делают руководителя. Лидер формирует среду, в которой сотрудники хотят развиваться, брать ответственность и достигать результатов. Без этой культуры любое обучение будет краткосрочным.'
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Обучение должно менять поведение',
      desc: 'Знания без применения бесполезны. Настоящий результат тренинга — не заполненные конспекты, а изменённые привычки: как менеджер начинает разговор, как отвечает на возражение, как закрывает сделку.'
    },
    {
      icon: 'ri-loop-left-line',
      title: 'Изменения происходят через практику',
      desc: 'Невозможно научиться продавать или управлять, слушая лекции. Только многократное повторение, обратная связь и работа над ошибками формируют устойчивые навыки. Поэтому 80% программы — практика.'
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Моя философия обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Это не просто красивые слова. Это принципы, на которых построена каждая программа и каждый тренинг.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {ideas.map((idea, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-8 hover:shadow-md transition-all duration-300 group cursor-default">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${idea.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{idea.title}</h3>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">{idea.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="mt-12 max-w-3xl mx-auto bg-teal-50 border border-teal-200 rounded-2xl p-8 text-center">
          <i className="ri-double-quotes-l text-4xl text-teal-300 mb-4 block"></i>
          <p className="text-lg md:text-xl text-teal-800 leading-relaxed italic font-medium">
            Я не верю в «волшебные таблетки» и мотивационные речи. Я верю в системную работу, практику и измеримый результат. Именно это я делаю для своих клиентов.
          </p>
          <p className="mt-4 text-teal-600 font-semibold">Алексей Сивко</p>
        </div>
      </div>
    </section>
  );
}